var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0V26C0 26.5304 0.210714 27.0391 0.585786 27.4142C0.960859 27.7893 1.46957 28 2 28H28V26H2V0Z",
    fill: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7H21V9H24.59L17 16.59L12.71 12.29C12.617 12.1963 12.5064 12.1219 12.3846 12.0711C12.2627 12.0203 12.132 11.9942 12 11.9942C11.868 11.9942 11.7373 12.0203 11.6154 12.0711C11.4936 12.1219 11.383 12.1963 11.29 12.29L4 19.59L5.41 21L12 14.41L16.29 18.71C16.383 18.8037 16.4936 18.8781 16.6154 18.9289C16.7373 18.9797 16.868 19.0058 17 19.0058C17.132 19.0058 17.2627 18.9797 17.3846 18.9289C17.5064 18.8781 17.617 18.8037 17.71 18.71L26 10.41V14H28V7Z",
    fill: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticIcon);
export default __webpack_public_path__ + "static/media/AnalyticIcon.f144a4073b7a6990fbbe230a9fbd8aff.svg";
export { ForwardRef as ReactComponent };